import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Form, Select } from 'antd';

const { Option } = Select;

export default function CustomSelect({
  error,
  label,
  options,
  touched,
  className,
  ...rest
}) {
  const handleFilterOption = useCallback(
    (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
    [],
  );

  return (
    <Form.Item
      hasFeedback={touched && !!error}
      help={touched && error}
      label={label}
      validateStatus={touched && error ? 'error' : ''}
      className={className}
    >
      <Select {...rest} filterOption={handleFilterOption}>
        {options.map(option => (
          <Option key={option.key} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
}

CustomSelect.propTypes = {
  error: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  touched: PropTypes.bool,
  className: PropTypes.string,
};

CustomSelect.defaultProps = {
  error: undefined,
  label: undefined,
  options: [],
  touched: false,
  className: undefined,
};
